import {NgModule} from "@angular/core";
import {BrowserModule} from "@angular/platform-browser";
import {HttpModule} from '@angular/http';
import {FormsModule} from '@angular/forms';
import {loginComponent} from "./login.component";
import {LoginService} from "./login.service";
import {verificarUsuarioComponent} from "./verificar-usuario.component";
import {verificarPreguntaComponent} from "./verificar-pregunta.component";
import {cambiarContrasenaComponent} from "./cambiar-contrasena.component";
import {nuevaContrasenaComponent} from "./nueva-contrasena.component";
import { ShowHideInput, ShowHideInput2, ShowHideInput3 } from "./show-hide-input.directive"; 
import { RouterModule } from "@angular/router";
import { Ng2Bs3ModalModule } from "../../../../node_modules/ng2-bs3-modal/ng2-bs3-modal";

@NgModule({
    declarations: [loginComponent, verificarUsuarioComponent, verificarPreguntaComponent, cambiarContrasenaComponent, nuevaContrasenaComponent, ShowHideInput, ShowHideInput2, ShowHideInput3],
    imports     : [BrowserModule,HttpModule,FormsModule,RouterModule,Ng2Bs3ModalModule],
    providers : [LoginService]
})

export class LoginModule {}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/login/login.module.ts